import { AsyncPipe, NgIf } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { OnInit } from '@angular/core';
import { LoginService } from '../../../services/login.service';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from "@angular/material/icon";
import { globalUser } from '../../../helpers/globalFields';

@Component({
  selector: 'app-session-warning-dialog',
  standalone: true,
  imports: [
    AsyncPipe,
    NgIf,
    MatDialogModule,
    MatButtonModule,
    MatIcon
  ],
  templateUrl: './session-warning-dialog.component.html',
  styleUrl: './session-warning-dialog.component.scss'
})
export class SessionWarningDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<SessionWarningDialogComponent>,
    private loginService: LoginService
  ) { }
  timeLeft$!: Observable<number>;


  ngOnInit(): void {
    this.timeLeft$ = globalUser.getRemainingSessionTime();

  }

  onRenewSession(): void {
    this.loginService.refresh().subscribe(res => {
      globalUser.setToken(res.accessToken, res.refreshToken);
    });
  }
  secondsToMinutes(totalseconds: number) {
    let hours = Math.floor(totalseconds / 3600);
    let minutes = Math.floor((totalseconds - 3600*hours) / 60);
    let seconds = Math.floor(totalseconds - 3600*hours - 60*minutes);
    return {hours, minutes, seconds};
  }
  onLogout(): void {
    globalUser.handleSessionExpiration();
  }
}
